<template>

</template>

<script>
import auth from '../../services/Auth'

export default {
  name: 'WeiboLogin',
  mounted () {
    const token = this.$route.query.token
    const name = this.$route.query.name
    const authorities = ['ROLE_USER']
    const data = {name, token, authorities}
    auth.loginSuccess(data)
    this.$router.push('/')
  }
}
</script>

<style scoped>

</style>
